/**
 * Created by Dhanya Akhil on 1/30/2017.
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../shared/modules/shared.module';
import { HomeService } from './services/home.service';
import { HomeComponent } from './components/home.component';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';  // this includes the core NgIdleModule but includes keepalive providers for easy wireup
import {AccountResourceService} from "../../shared/services/account-resource.service";
import {DocumentResourceService} from "../../shared/services/document-resource.service";
import { BsModalModule } from 'ng2-bs3-modal';


@NgModule({
  imports: [
    RouterModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    BsModalModule,
    NgIdleKeepaliveModule.forRoot(),
    TranslateModule.forChild()
  ],
  declarations: [HomeComponent],
  exports:[FormsModule,ReactiveFormsModule],
  providers: [HomeService, AccountResourceService, DocumentResourceService]
})
export class HomeModule {
}
